import { render, staticRenderFns } from "./PackageSelection.vue?vue&type=template&id=b9bfa7da&scoped=true"
import script from "./PackageSelection.vue?vue&type=script&lang=js"
export * from "./PackageSelection.vue?vue&type=script&lang=js"
import style0 from "./PackageSelection.vue?vue&type=style&index=0&id=b9bfa7da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bfa7da",
  null
  
)

export default component.exports